export default __webpack_public_path__ + "static/media/NodwinLogo.f2781bec.svg";